import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

const GridButtonRow = (props) => (
  <Grid
    item
    container
    spacing={3}
    direction="row"
    justify="flex-start"
    alignItems="center"
  >
    {props.children}
  </Grid>
);

GridButtonRow.propTypes = {
  children: PropTypes.node,
};

export default GridButtonRow;
